/* AUTAVEX — галереї ворсових килимків (без фото кольорів) */
window.AV_VORS_GAL=[
 /* 10 мм */
 ['42E42E35-98B2-4B80-AA75-CE79870C7A32.jpg?v=1786438180',
  '8EC3AFD1-DFD0-4926-B668-F47D7D7C71AF.jpg?v=1786438180',
  'D2829DE1-51F6-42CC-A613-384793467C5E.jpg?v=1786438180',
  'D6C748C2-5713-4F9B-9F85-57BC57473AD1.jpg?v=1786438180',
  '6FBC7951-313E-4CEB-9FD5-D404BC393C53.jpg?v=1786438180',
  'IMG-3734.webp?v=1786443292',
  'IMG-3743.jpg?v=1786442864',
  'IMG-3746.jpg?v=1786442864',
  'IMG-3747.jpg?v=1786442864',
  'IMG-3748.jpg?v=1786442863',
  'IMG-3749.jpg?v=1786442863'],
 /* 15 мм */
 ['IMG-3737.jpg?v=1786443245',
  'IMG-3738.jpg?v=1786442864',
  'IMG-3739.jpg?v=1786442863',
  'IMG-3740.jpg?v=1786442863',
  'IMG-3745.jpg?v=1786442864',
  '441829F9-A68B-47C8-8BCB-2E44BE1B9EED.webp?v=1786438180',
  '108B3B78-4DC4-4954-ADF2-A9639ECE9CF7.jpg?v=1786438180',
  '9F87F3EA-D3DF-4BD9-A5BC-67DE9824A096.jpg?v=1786438180',
  'FullSizeRender_2b48f066-9d75-4876-ac2d-4f75848294fd.jpg?v=1786443245',
  'FullSizeRender_378eb791-b593-4cd3-a1ac-f6f16b726a32.jpg?v=1786443245']
];
